export const addresses = {
  svgHelperAddress: "0x707531c9999AaeF9232C8FEfBA31FBa4cB78d84a",
  splatterAddress: "0x2538a10b7fFb1B78c890c870FC152b10be121f04",
  splatterArtAddress: "0x24432a08869578aAf4d1eadA12e1e78f171b1a2b",
  splatterToken: "0xdB05A386810c809aD5a77422eb189D36c7f24402",
};
